module.exports = __webpack_public_path__ + "static/media/23-1.a594bccd.mp3";